import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { searchQueryKeyMap } from '@/features/search/_utils/query-keys';
import type {
  ksAggregationTargetTypeEnum,
  ksAnalysisAxisEnum,
} from '@/utils/enum';
import type { z } from 'zod';
import { KsAnalysisModels } from '../_models/ks-analysis';

type KsAnalysisRequestParams = {
  fiscalYear: number;
  projectNumbers: string | null;
  q: string | null;
  textSearchCriteria: string | null;
  cascader: string | null;
  // 見える化サイト(PS)用。QueryStore(cascader)が使えないため、事業所管課室IDをカンマ区切りで直接送る。
  organizationIds: string | null;
  corporateNumber: string | null;
  // `total`（合計のみセンチネル）は API には送らない。null = 合計のみ（RS-4424）。
  analysisAxis: Exclude<z.infer<typeof ksAnalysisAxisEnum>, 'total'> | null;
  aggregationTargetType: z.infer<typeof ksAggregationTargetTypeEnum>;
};

export const useKsAnalysis = ({
  params,
}: {
  params: KsAnalysisRequestParams;
}) => {
  return useQuery({
    queryKey: searchQueryKeyMap.ksAnalysis(params),
    queryFn: async () => {
      const response = await axiosGet('/api/ks-analysis/', params);
      return KsAnalysisModels.parse(response);
    },
  });
};
